import { THealthDomainWithOverall } from './Health.types';
import type { GoalDto } from '@/types/generated/schemas';

export enum EGrowthGoalStatus {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
}

export enum EGrowthDomainGoalTrend {
  IMPROVING = 'IMPROVING',
  DECLINING = 'DECLINING',
}

export enum EGrowthDomain {
  MENTAL = 'MENTAL',
  PHYSICAL = 'PHYSICAL',
  SOCIAL = 'SOCIAL',
  VOCATIONAL = 'VOCATIONAL',
  SPIRITUAL = 'SPIRITUAL',
  PURPOSE = 'PURPOSE',
  FUN = 'FUN',
  OVERALL = 'OVERALL',
}

// Backed by the generated OpenAPI schema.
export type TDomainGoal = GoalDto;

export type TDomainGrowthZone = {
  domain: THealthDomainWithOverall;
  score: number;
  trend: EGrowthDomainGoalTrend;
  createdAt: string;
  goals: TDomainGoal[];
};

export type TCreateDomainGoal = { domain: THealthDomainWithOverall; text: string };
